import React, { use, useEffect, useState } from 'react'
import {Grid, Box, Paper, Typography, Container, Button, Stack, Avatar, 
    Select, MenuItem,
    RadioGroup, FormControl, FormLabel, FormControlLabel, Radio,
    TextField, 
    TableRow, TableCell
} from '@mui/material'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { List, ListItem, ListItemText, ListItemButton, CircularProgress } from '@mui/material';
import Api from '../Services/ApiPublic';
import StaticVar from '../Config/StaticVar';
import Dialog from '../Components/Dialog'
import DataTable from '../Components/DataTable'
import QRCode from 'react-qr-code';
import { set } from 'lodash';
import * as XLSX from "xlsx";

function formatDateToDDMMYYYY(inputDate) {
    try {
        // Convert input to Date object
        const date = new Date(inputDate);

        // Validate date
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date");
        }

        // Extract day, month, year
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    } catch (error) {
        console.error(error.message);
        return "";
    }
}

export default function CertificatePage() {
    const [certificateList, setCerticateList] = useState([])
    const [eventList, setEventList] = useState([])
    const [chooseEventList, setChooseEventList] = useState([])
    const [chooseEventYear, setChooseEventYear] = useState("0")
    const [chooseEventSemester, setChooseEventSemester] = useState("0")

    const getEventList = async(year, semester)=>{
        const response = await Api.getEventList({params:{year, semester}})
        setEventList(response)
    }

    const getCertificateList = async(chooseEventList)=>{
        const response = await Api.getCertificateData(chooseEventList)
        setCerticateList(response)
    }
    useEffect(()=>{ 
    },[])

   const data = [
    { name: "John", age: 30 },
    { name: "Sarah", age: 25 },
  ];

  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(certificateList.map(x=>{
        return {
            "CERTIFICATE NO": x.CERTIFICATE_NO,
            "PARTICIPANT NO": x.PARTICIPANT_NUMBER,
            "FULL NAME": x.FULL_NAME,
            "BIRTH": `${x.PLACEOFBIRTH}, ${formatDateToDDMMYYYY(x.DATEOFBIRTH)}`,
            "DOJO NAME": x.DOJO_NAME,
            "REGION NAME": x.REGION_NAME,
            "LAST KYU": x.LAST_KYU,
            "PRESENT KYU": x.PRESENT_KYU,
            "LAST BELT": x.LAST_BELT_NAME,
            "PRESENT BELT": x.PRESENT_BELT_NAME,
        }
    })); // JSON → Sheet
    const workbook = XLSX.utils.book_new();           // Workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, `Certificates`);

    // Tanpa file-saver
    XLSX.writeFile(workbook, "data.xlsx");
  };

  return (
    <Container maxWidth="xl"  sx={{p:1}}>
        <Paper elevation={3} sx={{p:2}}>
            <Stack direction="row" 
                spacing={2}
                sx={{
                    mt:2,
                    mb:2,
                    justifyContent: "flex-start",
                    alignItems: "center",
                }}>
                    <Typography>Filter By  : </Typography>
                    <Select value={chooseEventYear} onChange={e=>{
                        if(e.target.value !== "0" && chooseEventSemester !=="0"){
                            getEventList(e.target.value, chooseEventSemester)
                        }
                        setChooseEventYear(e.target.value)
                    }}>
                        <MenuItem value="0">Tahun</MenuItem>
                        {
                            Array.from({ length: 10 }, (_, i) => (new Date().getFullYear()) - i).map(item=>(<MenuItem value={item}>{item}</MenuItem>))
                        }
                    </Select>
                    <Select value={chooseEventSemester} onChange={e=>{
                        if(e.target.value !== "0" && chooseEventYear !=="0"){
                            getEventList(chooseEventYear, e.target.value)
                        }
                        setChooseEventSemester(e.target.value)
                    }}>
                        <MenuItem value="0">Semester</MenuItem>
                        <MenuItem value="I (SATU)">I (SATU)</MenuItem>
                        <MenuItem value="II (DUA)">II (DUA)</MenuItem>
                    </Select>

                    <Select value={chooseEventList} onChange={e=>{
                        if(e.target.value !== "0"){
                            getCertificateList(e.target.value)
                        }
                        setChooseEventList(e.target.value)
                    }}>
                        <MenuItem value="0">Events</MenuItem>
                        {
                            eventList && eventList.map(item=>(<MenuItem value={item.EVENT_ID}>{item.EVENT_NAME}</MenuItem>))
                        }
                    </Select>
            </Stack>
            <Button variant='contained' onClick={exportExcel}>Export Excel</Button>
            <DataTable headers={[
                {name : "NO", align:'center',width:10},
                {name : "CERTIFICATE NO", align:'center',width:100},
                {name : "PARTICIPANT_NO", align:'center',width:100},
                {name : "FULL NAME", align:'left'},
                {name : "BIRTH", align:'center', width:200},
                {name : "DOJO NAME", align:'center', width:250},
                {name : "REGION NAME", align:'center', width:250},
                {name : "LAST KYU", align:'center', width:80},
                {name : "PRESENT KYU", align:'center', width:80},
                // {name : "BELT NAME", align:'center', width:80},
            ]}> 
                {certificateList && certificateList.map((row, index) => (
                    <TableRow
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell align="center" component="th" scope="row">
                        {index+1}
                    </TableCell>
                    <TableCell align="center" scope="row">
                        {row.CERTIFICATE_NO}
                    </TableCell>
                    <TableCell align="center"scope="row">
                        {row.PARTICIPANT_NUMBER}
                    </TableCell>
                    {/* <TableCell align="center">{row.EVENT_NAME}</TableCell> */}
                    <TableCell align="left">{row.FULL_NAME}</TableCell>
                    <TableCell align="center">{row.PLACEOFBIRTH}, {formatDateToDDMMYYYY(row.DATEOFBIRTH)}</TableCell>
                    <TableCell align="center">{row.DOJO_NAME}</TableCell>
                    <TableCell align="center">{row.REGION_NAME}</TableCell>
                    <TableCell align="center">{row.LAST_KYU}</TableCell>
                    <TableCell align="center">{row.PRESENT_KYU}</TableCell>
                    {/* <TableCell align="center">{row.BELT_NAME}</TableCell> */}
                    </TableRow>
                ))}
            </DataTable>
        </Paper>
    </Container>
  )
}
